// extracted by mini-css-extract-plugin
export default {"details":"structured-error_details__OZWaC"};